import React, { Component } from "react"
import { Button, Input, InputNumber } from "antd"
import { get } from "lodash"
import { SketchPicker } from "react-color"
import SurveyConfigPreview from "../SurveyConfigPreview"
import Gallery from "../Gallery"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

class SecondStepConfig extends Component {
  state = {
    sketch_background_color: false,
    sketch_text_question_show: false,
    sketch_color_text_likert: false,
    sketch_color_button: false,
    modalGallery: false,
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  hideFooter = () => {
    const { configSurvey } = this.props
    const getUrlCutBgImage = this.props.background_image || ""
    const configSurveyBgImage =
      configSurvey.background_image ||
      this.props.uploadBgImage.defaultImage ||
      ""

    return (
      this.props.background_color.toUpperCase() ===
        configSurvey.background_color.toUpperCase() &&
      this.props.color_text_question.toUpperCase() ===
        configSurvey.color_text_question.toUpperCase() &&
      this.props.color_text_likert.toUpperCase() ===
        configSurvey.color_text_likert.toUpperCase() &&
      this.props.color_button.toUpperCase() ===
        configSurvey.color_button.toUpperCase() &&
      getUrlCutBgImage.slice(0, getUrlCutBgImage.indexOf("?")) ===
        configSurveyBgImage.slice(0, configSurveyBgImage.indexOf("?")) &&
      this.props.company_logo.slice(0, this.props.company_logo.indexOf("?")) ===
        configSurvey.company_logo.slice(
          0,
          configSurvey.company_logo.indexOf("?")
        ) &&
      this.props.background_image_opacity ===
        configSurvey.background_image_opacity &&
      this.props.company_logo_opacity === configSurvey.company_logo_opacity
    )
  }

  uploadImageBg = (event, isDelete = false) => {
    const fd = new FormData()

    if (isDelete) {
      fd.append("status", "delete")
      this.props.setStateFrom("background_image", "delete")
    } else {
      event.preventDefault()
      fd.append("uploaded_file", event.target.files[0])

      this.props.setStateFrom("background_image", event.target.files[0].name)
    }

    const params = {
      idSurvey: this.props.id_survey,
      data: fd,
    }

    this.props.uploadBgImageWatcher(params)
    this.fileInputBg.value = ""
  }

  uploadLogo = (event, isDelete = false) => {
    const fd = new FormData()

    if (isDelete) {
      fd.append("status", "delete")
      this.props.setStateFrom("logo_image", "delete")
    } else {
      event.preventDefault()
      this.props.setStateFrom("logo_image", event.target.files[0].name)
      fd.append("uploaded_file", event.target.files[0])
    }

    const params = {
      idSurvey: this.props.id_survey,
      data: fd,
    }

    this.props.uploadLogoWatcher(params)
    this.fileInputLogo.value = ""
  }

  render() {
    const { uploadBgImage } = this.props
    const { modalGallery } = this.state
    const backgroundImageVoid =
      get(this.props, "background_image", "") ||
      get(uploadBgImage, "defaultImage", "")

    return (
      <div className="first-step-container">
        <div style={{ minHeight: 734 }}>
          <div className="first-step-container-title">DISEÑO</div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Color de fondo</span>
            <div
              className="color-picker-survey"
              style={{ backgroundColor: this.props.background_color }}
              onClick={() =>
                this.setStateFrom(
                  "sketch_background_color",
                  !this.state.sketch_background_color
                )
              }
            />
            {this.state.sketch_background_color && (
              <div
                className="measurement-mail-configuration-colorpicker"
                style={{ bottom: -240, zIndex: 1 }}
                onMouseLeave={() =>
                  this.setStateFrom("sketch_background_color", false)
                }>
                <SketchPicker
                  color={this.props.background_color}
                  onChangeComplete={({ hex }) =>
                    this.props.setStateFrom("background_color", hex)
                  }
                />
              </div>
            )}
          </div>
          <div className="border-gray-bottom">
            <div className="first-step-container-item first-step-container-item-horizontal">
              <span>Imagen de fondo</span>
              {!(
                backgroundImageVoid.slice(
                  0,
                  backgroundImageVoid.indexOf("?")
                ) ===
                get(uploadBgImage, "defaultImage", "").slice(
                  0,
                  get(uploadBgImage, "defaultImage", "").indexOf("?")
                )
              ) ? (
                <Button
                  loading={this.props.isLoadingUploadBgImage}
                  className="btnDelete"
                  onClick={() => this.uploadImageBg("", true)}>
                  Eliminar
                </Button>
              ) : (
                <Button
                  loading={this.props.isLoadingUploadBgImage}
                  onClick={() => {
                    // this.setState({ modalGallery: true });
                    this.fileInputBg.click()
                  }}>
                  Agregar
                </Button>
              )}
              <input
                style={{ display: "none" }}
                type="file"
                onChange={(e) => this.uploadImageBg(e)}
                ref={(fileInputBg) => (this.fileInputBg = fileInputBg)}
              />
            </div>
            <div className="first-step-bg-image-container">
              <span
                className="first-step-bg-image"
                style={{
                  backgroundImage: `url(${this.props.background_image})`,
                }}
              />
              <div className="first-step-bg-image-opacity">
                <InputNumber
                  max={100}
                  min={0}
                  value={this.props.background_image_opacity}
                  onChange={(e) =>
                    this.props.setStateFrom(
                      "background_image_opacity",
                      typeof e === "object" ? 100 : e
                    )
                  }
                />
              </div>
            </div>
          </div>
          <div className="border-gray-bottom">
            <div className="first-step-container-item first-step-container-item-horizontal">
              <span>Logo</span>
              {this.props.company_logo !== "" ? (
                <Button
                  loading={this.props.isLoadingUploadLogo}
                  onClick={() => this.uploadLogo("", true)}
                  className="btnDelete">
                  Eliminar
                </Button>
              ) : (
                <Button
                  loading={this.props.isLoadingUploadLogo}
                  onClick={() => this.fileInputLogo.click()}>
                  Agregar
                </Button>
              )}
              <input
                style={{ display: "none" }}
                type="file"
                onChange={(e) => this.uploadLogo(e)}
                ref={(fileInputLogo) => (this.fileInputLogo = fileInputLogo)}
              />
            </div>
            {this.props.company_logo && (
              <div className="first-step-bg-image-container">
                <span
                  className="first-step-bg-image"
                  style={{ backgroundImage: `url(${this.props.company_logo})` }}
                />
                <div className="first-step-bg-image-opacity">
                  <InputNumber
                    max={100}
                    min={0}
                    value={this.props.company_logo_opacity}
                    onChange={(e) =>
                      this.props.setStateFrom(
                        "company_logo_opacity",
                        typeof e === "object" ? 100 : e
                      )
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Color texto preguntas</span>
            <div
              className="color-picker-survey"
              style={{ backgroundColor: this.props.color_text_question }}
              onClick={() =>
                this.setStateFrom(
                  "sketch_text_question_show",
                  !this.state.sketch_text_question_show
                )
              }
            />
            {this.state.sketch_text_question_show && (
              <div
                className="measurement-mail-configuration-colorpicker"
                onMouseLeave={() =>
                  this.setStateFrom("sketch_text_question_show", false)
                }>
                <SketchPicker
                  color={this.props.color_text_question}
                  onChangeComplete={({ hex }) =>
                    this.props.setStateFrom("color_text_question", hex)
                  }
                />
              </div>
            )}
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Color numeración escala Likert</span>
            <div
              className="color-picker-survey"
              style={{ backgroundColor: this.props.color_text_likert }}
              onClick={() =>
                this.setStateFrom(
                  "sketch_color_text_likert",
                  !this.state.sketch_color_text_likert
                )
              }
            />
            {this.state.sketch_color_text_likert && (
              <div
                className="measurement-mail-configuration-colorpicker"
                onMouseLeave={() =>
                  this.setStateFrom("sketch_color_text_likert", false)
                }>
                <SketchPicker
                  color={this.props.color_text_likert}
                  onChangeComplete={({ hex }) =>
                    this.props.setStateFrom("color_text_likert", hex)
                  }
                />
              </div>
            )}
          </div>
          <div className="first-step-container-item first-step-container-item-horizontal border-gray-bottom">
            <span>Color de botones y título</span>
            <div
              className="color-picker-survey"
              style={{ backgroundColor: this.props.color_button }}
              onClick={() =>
                this.setStateFrom(
                  "sketch_color_button",
                  !this.state.sketch_color_button
                )
              }
            />
            {this.state.sketch_color_button && (
              <div
                className="measurement-mail-configuration-colorpicker"
                onMouseLeave={() =>
                  this.setStateFrom("sketch_color_button", false)
                }>
                <SketchPicker
                  color={this.props.color_button}
                  onChangeComplete={({ hex }) =>
                    this.props.setStateFrom("color_button", hex)
                  }
                />
              </div>
            )}
          </div>
          {!this.hideFooter() && (
            <div className="footer-survey-config">
              <Button onClick={this.props.updateAllState}>Cancelar</Button>
              <Button
                type="primary"
                onClick={() => {
                  const {
                    background_color,
                    color_button,
                    color_text_likert,
                    color_text_question,
                    company_logo_opacity,
                    background_image_opacity,
                  } = this.props

                  woopraTrack("Guardar configuración de diseño cuestionario")

                  const isDefaultImage = !(
                    backgroundImageVoid.slice(
                      0,
                      backgroundImageVoid.indexOf("?")
                    ) ===
                    get(uploadBgImage, "defaultImage", "").slice(
                      0,
                      get(uploadBgImage, "defaultImage", "").indexOf("?")
                    )
                  )

                  const params = {
                    idSurvey: this.props.id_survey,
                    editSettingSegment: this.props.editSettingSegment,
                    params: {
                      background_color,
                      background_image: this.props.uploadBgImage.pathImage
                        ? this.props.background_image
                        : null,
                      company_logo: this.props.uploadLogo || "",
                      company_logo_opacity,
                      background_image_opacity,
                      color_button,
                      color_text_likert,
                      color_text_question,
                    },
                  }

                  this.props.updateConfigSurveyWatcher(params)
                }}>
                Guardar
              </Button>
            </div>
          )}
        </div>
        <SurveyConfigPreview {...this.props} />
        <Gallery
          visible={modalGallery}
          setStateFrom={this.setStateFrom}
          onOk={(imgUploaded) => {
            const fd = new FormData()
            fd.append("uploaded_file", imgUploaded)

            const params = {
              idSurvey: this.props.id_survey,
              data: fd,
            }

            this.props.uploadBgImageWatcher(params)
          }}
        />
      </div>
    )
  }
}

export default SecondStepConfig
